import { computed } from 'vue';
import { DefaultTableSelectorOptions } from '@/models/i-table-selector';
import { Enrolment } from '@/models/enrolment';
import { RouteEnums } from '@/models/route-enums';
import { IEnrolmentTuitionFeeCounter } from '@/models/i-enrolment-counters';
import TableFilter from '@/presentation/components/generalizations/table-selectors/filters/table-filter';
import TableSelectorOption from '@/presentation/components/generalizations/table-selectors/table-selector-option';
import store from '@/store';

export default class TableFilterTuitionFee extends TableFilter {
	get defaultOptions(): TableSelectorOption[] {
		return [new TableSelectorOption(DefaultTableSelectorOptions.DEFAULT, 'All tuition fees')];
	}

	private onHistoryPage = computed((): boolean => {
		const router = store.getters.router();
		return router.current === RouteEnums.HISTORY;
	});

	public createOptions(): TableSelectorOption[] {
		const tuitionCounters: IEnrolmentTuitionFeeCounter[] = [];
		this.enrolmentsFilteredByOtherFilters.value.forEach((enrolment) => {
			if (!enrolment.tuitionFeeString) {
				return;
			}

			const existingCounter = tuitionCounters.find((counter) => counter.tuition === enrolment.tuitionFeeString);
			if (existingCounter) {
				existingCounter.facet++;
				return;
			}

			tuitionCounters.push({
				label: enrolment.tuitionFeeString,
				tuition: enrolment.tuitionFeeString,
				facet: 1
			});
		});

		return tuitionCounters.map((counter) => new TableSelectorOption(counter.tuition, counter.label, counter.facet));
	}

	public doesEnrolmentMatchFilter(enrolment: Enrolment): boolean {
		const option = this.selectedOptionAsOption.value;
		if (((!option || option.isDefaultOption) && !this.selectedOption.value) || this.onHistoryPage.value) {
			return true;
		}

		if (!enrolment.tuitionFeeString) {
			return false;
		}

		return enrolment.tuitionFeeString === this.selectedOption.value.toString();
	}
}
